import React from "react";
import Navbar from '../navBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/md-dark-indigo/theme.css";
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css';
import 'react-slideshow-image/dist/styles.css'
import { useTranslation } from "react-i18next";
import FooterComponent from "../footer";
import "../../style/table.css"
import TableFeldspat from "../feldspatTable";
import { Menu } from "primereact/menu";
import FeldspatMenu from "../feldspatMenu";
import "../../style/commonMobile.css";

const FeldspatFK6103 = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <PrimeReactProvider>
            <Navbar />
            <div className="feldspatContainer">
                <div style={{ display: "block" }}>
                    <FeldspatMenu />
                </div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                    <TableFeldspat baslik="TEKNOMADEN FELDSPAR (-10MM) FK6103 TDS" plantAddress="Yeşilköy/Kavaklıdere/Muğla" kod="FK6103" humidity="3" oilAbsorb="" na2o="5.80" k2o="0.48" cao="0.15" fe2o3="0.10" tio2="0.25" al2o3="11.49" mgo="0.10" p2o5="0.00" sio2="81.20" kk="0.43" l="71,36" a="1,50" b="14,36" albit="49.1" ortoklas="2.8" anortit="0.7" kaolinit="2.9" kuvars="44.4" />
                </div>
            </div>
            <FooterComponent />
        </PrimeReactProvider>
    );
}
export default FeldspatFK6103;